import React from 'react'
import PropTypes from 'prop-types'
import { Container, Notification } from '@offerzen/pinata'

import Toolbar from '@/CandidateExperience/legacyLib/common/Toolbar'

import styles from './styles'

export const NOTIFICATION_ID = 'PageLayoutNotificationBanner'

const PageLayout = ({ body, toolbarContent, notificationBannerContent, notificationBannerTheme = 'dark' }) => {
  return (
    <>
      <If condition={toolbarContent}>
        <section className={styles.toolbarWrapper}>
          <Container>
            <Toolbar className={styles.toolbar} left={toolbarContent} />
          </Container>
        </section>
      </If>

      <If condition={notificationBannerContent}>
        <div className={styles.notificationWrapper} id={NOTIFICATION_ID}>
          <Notification theme={notificationBannerTheme} className={styles.notification}>
            <Container>{notificationBannerContent}</Container>
          </Notification>
        </div>
      </If>

      <Container className={styles.container}>{body}</Container>
    </>
  )
}

PageLayout.propTypes = {
  body: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  toolbarContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  notificationBannerContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  notificationBannerTheme: PropTypes.string,
}

export default PageLayout
